<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <el-form :model="queryParams" label-position="left" class="demo-form-inline">
          <div class="add-basic-information">
            <div class="add-title">
              <span class="basic title-font-style">备货信息</span>
            </div>
            <div
              class="add-content details-line-height"
              style="padding-left:50px;padding-bottom:10px"
            >
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货编号：">
                      <span>{{queryParams.stockupCode || '--'}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货方式：">
                      <span>{{queryParams.distributionType==1?'仓储备货':'调拨备货'}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="预计发货时间：">
                      <span>{{queryParams.deliveryTime|dateFilterL}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货仓库：">{{queryParams.storageName || '--'}}</el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="联系电话：">{{queryParams.storagePhone || '--'}}</el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="仓库地址：">{{queryParams.storageAddress || '--'}}</el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发起人：">{{queryParams.createUser || '--'}}</el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="请求备货时间：">{{queryParams.createDate|dateFilterL}}</el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="add-basic-information">
            <div class="add-title add-title1" style="padding-left:20px;padding-top:20px">
              <div>
                <span class="basic title-font-style">备货产品详情</span>
              </div>
              <span style="text-align:right;padding-right:0px;">
                <el-button @click="toExport">导出备货单</el-button>
                <el-button @click="toMigration(1)">批量迁移货架</el-button>
              </span>
            </div>
            <div class="box-table" style="padding-top:0px;padding-bottom:30px">
              <el-table
               max-height="378"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                @selection-change="handleSelectionChange"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="品牌" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.brandName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" width="120" prop='proName' show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="型号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{scope.row.proModel || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" width="100" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proOrdernum || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="单位">
                  <template slot-scope="scope">
                    <div>{{scope.row.proUnit || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架" prop='shelvesName' show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="备货数量">
                  <template slot-scope="scope">
                    <div>{{scope.row.stockupCount || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架库存数量" width="120">
                  <template slot-scope="scope">
                    <div>{{scope.row.counts || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="历史已锁库" width="110">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCounts || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" width="100px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.warehouseBatchCode || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="本次锁库数量" width="120">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCount || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="实际库存量" width="120">
                  <template slot-scope="scope">
                    <div>{{scope.row.count || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="迁移货架" width="180" fixed="right"  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-select
                      @change="changeStock(scope.row.migrationName,scope.$index)"
                      v-model="scope.row.migrationName"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in scope.row.storageShelvesListVos"
                        :key="item.ssId"
                        :label="item.shelvesName"
                        :value="item.ssId"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
              <div>
                <div
                  style="margin:14px 0 14px 0;color:#D35E5E;font-size:12px"
                >*如在备货途中变更产品所在货架，可通过迁移货架，选择产品实际所在货架</div>
                <el-button type="primary" @click="toMigration(2)">确认迁移</el-button>
                <el-button @click="toMigration(0)">放弃迁移</el-button>
              </div>
            </div>
          </div>
        </el-form>
        <!-------------- 迁移弹窗 ------------------->
        <migrate-popup @cancle='cancleList' ref="migratePopupRefs"></migrate-popup>
      </div>
    </div>
  </div>
</template>

<script>
import migratePopup from '../dialog/migratePopup'
import { queryStockupContentMigration } from '@/api/storage/storage'
import { downLoadFileBlob } from '@/util/tool'
import { addStorageStockCoeDerive } from '@/api/purchase/purchaseManage'
export default {
  components: {
    'migrate-popup': migratePopup
  },
  data () {
    return {
      check: [], // 选中的列表数据
      list: [], // 备货列表
      queryParams: {}, // 表单数据
      pitchOnPpId: [],
      loadingTable: false,
      isUpdate: false,
      distributionType: '', // 备货方式
      sbId: '',
      chackList: [], // 列表选中的数据
      idsArr: [], // 筛选后的数组
      selectIds: []// 切换货架后的id
    }
  },
  mounted () {
    this.queryStockupContentMigration()
    this.distributionType = this.$route.query.distributionType
  },
  beforeRouteLeave: (to, from, next) => {
    if (to.name === 'stockDetail') {
      next('/storage/storageManage/inventoryStockList')
    } else {
      next()
    }
  },
  methods: {
    // 根据备货产品id和备货方式distributionType 仓库方案id ocssIds 获取备货详情
    queryStockupContentMigration () {
      var id = localStorage.getItem('id')
      var ocssIds = localStorage.getItem('ocssIds')
      var distributionType = localStorage.getItem('distributionType')
      queryStockupContentMigration(ocssIds, id, distributionType).then(res => {
        if (res.data.code === 200) {
          this.queryParams = res.data.obj.storageStockupVo // 基本信息
          this.list = res.data.obj.stockupContentMigrationsVoList // 备货产品详情
          this.sbId = this.queryParams.sbId
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 全选，单选事件
    handleSelectionChange (val) {
      this.chackList = val
    },
    // 迁移货架change事件
    changeStock (val, i) {
      this.list[i].migrationName = val
      this.list[i].ssIds = val
    },
    // 取消选中
    cancleList () {
      this.chackList = []
      this.queryStockupContentMigration()
    },
    // 导出备货单
    toExport () {
      const params = {}
      params.distributionType = this.$route.query.distributionType
      params.ocssIds = this.$route.query.ocssIds
      params.ocsId = this.$route.query.id
      if (this.$route.query.distributionType === 1) {
        params.stockUrl = this.$store.state.optionsListGuidwarse
      } else {
        params.stockUrl = this.$store.state.optionsListGuid
      }

      addStorageStockCoeDerive(params)
        .then((res) => {
          downLoadFileBlob(this, res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 放弃迁徙 type=0放弃迁移确认 1批量迁移货架 2迁移确认
    toMigration (type) {
      if (type === 2) {
        this.idsArr = []
        this.list.forEach(ele => {
          const paramsId = {
            ocssId: ele.ocssId,
            ssId: ele.ssIds
          }
          this.idsArr.push(paramsId)
        })
        if (this.idsArr.some(m => !m.ssId)) {
          this.$message.error('请选择要迁移的产品')
        } else {
          this.handleSelectionChange()
          this.$refs.migratePopupRefs.onInitialize(type, this.sbId, this.idsArr, this.$route.query.id, this.$route.query.distributionType, this.$route.query.ocssIds)
        }
      } else if (type === 1) {
        if (this.chackList.length !== 0) {
          this.chackList.forEach(element => {
            const paramsId = {
              ocssId: element.ocssId,
              ssId: element.ssIds
            }
            this.idsArr.push(paramsId)
          })
          this.handleSelectionChange()
          this.$refs.migratePopupRefs.onInitialize(type, this.sbId, this.idsArr, this.$route.query.id, this.$route.query.distributionType, this.$route.query.ocssIds)
        } else {
          this.$message.error('请选择要迁移的产品')
        }
      } else {
        this.$refs.migratePopupRefs.onInitialize(type, this.sbId, this.idsArr, this.$route.query.id, this.$route.query.distributionType, this.$route.query.ocssIds)
      }
    },
    // 跳产品详情页
    detailModel (row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    // 设置头部颜色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}

</script>
<style lang="scss" scoped>
.add-basic-information .bottom {
  padding: 30px;
}

.add-title1 {
  display: flex;
  justify-content: space-between;
}
.logistics-information {
  font-size: 16px;
  font-weight: bold;
  color: #4e555b;
  margin-bottom: 10px;
}
.el-table__fixed-right {
  height:73px;
}
</style>
